import data from "../../../../../src/TreeView/TreeView.docs.json";
import * as React from 'react';
export default {
  data,
  React
};